import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Link, useLocation } from 'react-router-dom';

const CustomListItem = ({
  to,
  title,
  icon,
}: {
  to: string;
  title: string;
  icon: JSX.Element;
}): JSX.Element => {
  const location = useLocation();
  const { pathname } = location;

  return (
    <Link
      style={{
        textDecoration: 'none',
        color: '#000000de',
      }}
      to={to}
    >
      <ListItem button selected={location && to === pathname}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={title} />
      </ListItem>
    </Link>
  );
};

export default CustomListItem;
